import { type NavigationAnchor } from "@/components/layout/types";
import { Module, PATH_CONTRACTORS, PATH_USERS } from "@/constants";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { Users, UserCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export const useUsersMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return [
    {
      icon: Users,
      url: PATH_USERS,
      permission: permissions[Module.Users].can_read,
      title: t("navigation.users"),
    },
    {
      icon: UserCheck,
      url: PATH_CONTRACTORS,
      permission: permissions[Module.Contractors].can_read,
      title: t("navigation.contractors"),
    },
  ];
};
